export default __webpack_public_path__ + "static/media/snehanv.aec5e367.jpg";